import React from 'react';
import { Flex, Modal, Result, Typography } from 'antd';
import { BlackButton } from 'common/components/UI';
import { useIntl } from 'react-intl';

type ReplaceModalProps = {
  isOpen: boolean;
  onClose: () => unknown;
  onReplace: () => unknown;
};

const ReplaceModal: React.FC<ReplaceModalProps> = ({
  isOpen,
  onReplace,
  onClose,
}) => {
  const { formatMessage: t } = useIntl();

  return (
    <Modal title="&nbsp;" open={isOpen} footer={false} onCancel={onClose}>
      <Result
        status="warning"
        title={t({ id: 'card.blocked.replace.alert.title' })}
        subTitle={
          <>
            <Typography.Text>
              {t({ id: 'card.blocked.replace.alert.desc' })}
            </Typography.Text>
          </>
        }
        extra={
          <Flex gap={8} vertical>
            <BlackButton type="primary" key="replace" block onClick={onReplace}>
              {t({ id: 'card.blocked.replace' })}
            </BlackButton>
            <BlackButton key="cancel" onClick={onClose} block>
              {t({ id: 'button.simple.cancel' })}
            </BlackButton>
          </Flex>
        }
      />
    </Modal>
  );
};

export default ReplaceModal;
